import Character from './character'
import CharacterBuilder from './character/character-builder'

export default class Rulebook {
  constructor (rulebooks, mechanisms) {
    Object.assign(this, { rulebooks, mechanisms, playbooks: [] })

    this.characters = {
      builder: new CharacterBuilder(this),
      load: data => Character.deserialize(data, this)
    }
  }
}
